/** Maps backend role tokens to short display labels in the admin UI. */
export const ROLE_LABELS = {
    "WB-ADMIN": "WhatsApp Admin",
    "WB-USER": "WhatsApp User",
    "WB-AGENT": "BOT",
    "WB-CHAT": "CHAT",
    "CRM-ADMIN": "CRM Admin",
    "CRM-USER": "CRM user",
    PERSONAL: "Personal WhatsApp",
    EMAIL: "Business email",
    "EMAIL-ADMIN": "Email admin",
};

export function parseUserRoles(userRole) {
    if (userRole == null || userRole === "") return [];
    if (Array.isArray(userRole)) return userRole.map((s) => String(s).trim()).filter(Boolean);
    return String(userRole)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
}

export function formatRoleLabel(token) {
    if (token == null || token === "") return "";
    const key = String(token).trim().toUpperCase();
    return ROLE_LABELS[key] || String(token).trim();
}

/** Role token to remove on revoke (one at a time). Prefers WB-USER, then WB-AGENT, then CRM-USER. */
export function primaryManagedRoleToRevoke(userRoleStr) {
    const roles = parseUserRoles(userRoleStr).map((r) => r.toUpperCase());
    for (const r of ["WB-USER", "WB-AGENT", "CRM-USER"]) {
        if (roles.includes(r)) return r;
    }
    return null;
}

export function rowIsAdminOrPrivileged(userRoleStr) {
    const roles = parseUserRoles(userRoleStr).map((r) => r.toUpperCase());
    return roles.some((r) => r === "WB-ADMIN" || r === "CRM-ADMIN");
}
